import React, { useState } from 'react'
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SearchModal } from './SearchModal'

const SEARCH_BAR_CONTAINER_CLASS =
  'hidden md:flex h-full items-center ml-auto px-2 lg:px-4 flex-shrink-0'
const SEARCH_BAR_CLASS =
  'flex items-stretch h-14 w-[20rem] lg:w-[29rem] overflow-hidden border-[3px] border-actionable bg-contentareabackground cursor-pointer focus:outline-none'
const SEARCH_LABEL_CLASS =
  'flex flex-1 items-center px-5 font-heading font-medium text-xl text-darkgray bg-contentareabackground'
const SEARCH_ICON_CONTAINER_CLASS =
  'flex items-center justify-center w-14 bg-actionable text-white text-xl'

export interface SearchBarProps {
  onSearchUpdate?: (s: string) => void
  renderResults?: (onResultClick?: () => void) => JSX.Element | JSX.Element[]
}

export const SearchBar: React.FC<SearchBarProps> = ({
  onSearchUpdate,
  renderResults,
}) => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleOpenModal = () => {
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
    if (onSearchUpdate) {
      onSearchUpdate('')
    }
  }

  const handleModalSearchUpdate = (query: string) => {
    if (onSearchUpdate) {
      onSearchUpdate(query)
    }
  }

  return (
    <>
      <div className={SEARCH_BAR_CONTAINER_CLASS}>
        <button
          type="button"
          data-testid="app-search-trigger"
          className={SEARCH_BAR_CLASS}
          onClick={handleOpenModal}
          aria-label="Open search"
        >
          <span data-testid="app-search-label" className={SEARCH_LABEL_CLASS}>
            Search
          </span>
          <span className={SEARCH_ICON_CONTAINER_CLASS}>
            <FontAwesomeIcon icon={faSearch} size="xl" />
          </span>
        </button>
      </div>

      <SearchModal
        isOpen={modalOpen}
        onClose={handleCloseModal}
        onSearchUpdate={handleModalSearchUpdate}
        renderResults={renderResults}
        placeholder="Search profiles and events..."
      />
    </>
  )
}
